import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/` is not a screen. The manifest points at /tasks so an installed launch
 * skips this, but links to the bare origin still have to land somewhere.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/tasks", replace: true });
  },
});
